import React, { useState, useRef } from 'react';
import './Login.css';

import { useAuth } from '../../Auth';
import LoginRoutes from '../../components/loginpageroutes';

import {
    LazyLoadImage,
    LazyLoadComponent,
} from 'react-lazy-load-image-component';

// Assets
// Background video
const BannerBg = require('./videos/login-page-video.mp4');
const BannerBg_LazyLoadImg = require('./img/login-lazyload.png');

// Images

const Login: React.FC = () => {

    // Section for the video and its lazyLoad functionality
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    const { login, logout, isAuthenticated, error, username, first_name } = useAuth();
    const [loginUsername, setLoginUsername] = useState('');
    const [password, setPassword] = useState('');

    const formRef = useRef<HTMLFormElement>(null);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        await login(loginUsername, password);
    };

    return (
        <div>
            <div className={isAuthenticated ? 'login-container logged-already' : 'login-container'}>
                {!isVideoLoaded && (
                    <LazyLoadComponent
                        placeholder={<img src={BannerBg_LazyLoadImg} alt="fallback" />}
                    >
                        <LazyLoadImage
                            src={BannerBg_LazyLoadImg}
                            alt="fallback"
                            className="background-media"
                        />
                    </LazyLoadComponent>
                )}

                <video
                    className={`background-media ${isVideoLoaded ? '' : 'hidden'}`}
                    src={BannerBg}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onLoadedData={() => setIsVideoLoaded(true)}
                />

                <div className="dark-overlay"></div> {/* ← Overlay */}

                {/* Login content overlay */}
                <div className={`login-inner ${!isAuthenticated ? 'inner-for-form' : ''}`}>
                    {isAuthenticated ? (
                        <>
                            <div className='login-welcome'>
                                <h1>Welcome, {first_name !== "" ? first_name : username.split("@")[0]}!</h1>
                                <h2>Ready to explore?</h2>
                                <h3>Use the menu to dive into your tools and insights</h3>
                                {/* <button onClick={logout} className="btn btn-danger logout-btn">
                                    Log out
                                </button> */}
                            </div>
                            <LoginRoutes />
                        </>
                    ) : (
                        <>
                            <h1 className="LogText">Log In</h1>
                            <div className="login-form-wrapper">
                                <form
                                    ref={formRef}
                                    onSubmit={handleSubmit}
                                    className="login-form"
                                >
                                    <div className="mb-3">
                                        <label htmlFor="username" className="form-label">Username</label>
                                        <input
                                            type="text"
                                            id="username"
                                            className="form-control"
                                            value={loginUsername}
                                            onChange={(e) => setLoginUsername(e.target.value)}
                                            placeholder="Enter your username"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <input
                                            type="password"
                                            id="password"
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="Enter your password"
                                        />
                                    </div>
                                </form>
                                {error && (
                                    <div className="login-tooltip">
                                        {error}
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>


            {!isAuthenticated && (
                <div className='around-submit-btn'>
                    <button
                        type="button"
                        className="submit-btn"
                        onClick={() => formRef.current?.requestSubmit()}
                    >
                        Sign In
                    </button>
                </div>
            )}
        </div>
    );
};

export default Login;
